import React, { useState} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
/* import Navigation from '../Navigation/Navigation'; */
import '../Privacy/Privacy.css'

function Terms (){
  const navigate = useNavigate();
  
    return (
      <section className="content" name="terms and conditions">
        <h1>VIX ACADEMY TERMS & CONDITIONS</h1>
        <h3>WEBSITE TERMS OF USE</h3>
        <div className="content-area">
        
          <p className="content-area text-content ">
              By accessing or using this website (the «site»), you acknowledge and agree to the disclaimers and terms and conditions («terms») set forth below. 
              Please ensure that you (referred to as the «user», «you» or «your» in these Terms and Conditions) read these Terms and Conditions with care. 
              If you do not agree to these Terms and Conditions, you should not use the site. These Terms apply to your use of the site, which is operated and owned by VIX ACADEMY.
          </p>
          <p className="content-area text-content">
            You must be 18 years of age to become a member of the VixAcademy service. The member who created the VixAcademy account and whose Payment Method 
            is charged is referred to here as the «Account Owner» or a «Member» having a «Membership».
          </p>
          <h3>1. About Vix Academy and Scope of Services</h3>
            <div className="content-area text-content">
              <ul className="terms-list">
                <li className="terms-item noStyle"> <b>1.1.</b> VixAcademy provides access to online educational content, learning materials, and related services (collectively, the "Services").</li>
                <li className="terms-item noStyle"> <b>1.2.</b> Courses may include, without limitation:
                  <ul className="terms-item-list">
                    <li>HTML & CSS Course</li>
                    <li>Pyhton Programming Course</li>
                    <li>JavaScript for Beginners</li>
                    <li>Digital Design Course</li>
                    <li>SEO</li>
                    <li>Social Media Marketing Course</li>
                    <li>Google Sites Course</li>
                    <li>Trading Fundamentals Program</li>
                  </ul>
                </li>
                <li className="terms-item noStyle"><b>1.3.</b> These Terms govern your use of the site and Services, including any purchase, Membership,
                  and access to course materials.</li>
              </ul>
            </div>
          <h3>2. Service availability and regions</h3>
          <div className="content-area text-content">
            <ul className="terms-list">
              <li className="terms-item noStyle"> <b>2.1.</b> The Services are offered to users in, or accessing the site from, the following regions (subject to legal and regulatory limitations): France, Italy, 
                Brazil, Turkey, Latin America and Asia including Hong Kong, Taiwan, Singapore, and Malaysia.
              </li>
              <li className="terms-item noStyle"> <b>2.2.</b> The Services are not intended for use in any jurisdiction where offering or accessing the Services would be unlawful. 
                You are responsible for ensuring that your use of the site complies with local laws.
              </li>
              <li className="terms-item noStyle">
                Nothing in these Terms excludes or limits mandatory consumer protections that apply in your country of residence.
              </li>
            </ul>
          </div>  
          <h3>3. Definitions</h3>
          <div className="content-area text-content">
            <span className="terms-item">“Content”: all lessons, videos, text, templates, downloads, files, quizzes, and materials provided through the Services.</span>
            <span className="terms-item">“Membership”: your paid access to a course, bundle, or the platform, purchased for a one-time fee (unless the checkout page expressly states otherwise).</span>
            <span className="terms-item">“Payment Method”: the payment instrument you provide.</span>
          </div>
          <h3>4. Eligibility, accounts, and security</h3>
          <div className="content-area text-content">
            <ul className="terms-list">
              <li className="terms-item noStyle"><b>4.1. </b> You confirm you are at least 18 years old and capable of entering into a binding agreement. </li>
              <li className="terms-item noStyle"><b>4.2. </b> You agree to provide accurate and complete registration information and keep it updated. </li>
              <li className="terms-item noStyle"><b>4.3. </b> You are responsible for maintaining the confidentiality of your login credentials and for all activity on your account.</li>
            </ul>
          </div>
          <h3>5. Payments (one-time fees), access, and taxes</h3>
          <div className="content-area text-content">
            <ul className="terms-list">
              <li className="terms-item noStyle"><b>5.1. </b>One-time payments: Vix Academy sells courses and/or access as one-time purchases. 
                Unless clearly stated at checkout, there are no recurring subscription charges.
              </li>
              <li className="terms-item noStyle"><b>5.2. </b>Access delivery: Access to Content is typically provided digitally and may be available 
                immediately after payment confirmation.
              </li>
              <li className="terms-item noStyle"><b>5.3. </b> Pricing and inclusions: The price, currecny, what is included, and any access period (if applicable) are shown at 
                checkout or on the product page and form part of these Terms.
              </li>
              <li className="terms-item noStyle"><b>5.4. </b> Taxes: Prices may include or exclude VAT/GST/sales taxes depending on your location and applicable law. 
                You are responsible for any taxes not collected at checkout.
              </li>
            </ul>
          </div>
          <h3>6. Refunds and cancellation (one-time Membership fees)</h3>
          <div className="content-area text-content">
            <ul className="terms-list">
              <li className="terms-item noStyle"><b>6.1. </b> Refund rule: All Membership fees are fully earned upon payment and are non-refundable, except during the first ninety (90)
               days since the beginning of the Membership under the condition that you have viewed no more than fifty percent (50%) of the lessons made available 
              </li>
              <li className="terms-item noStyle"><b>6.2. </b>How to request a refund: You can request a refund by emailing support@vixacademy.com stating your wish to receive a refund and your full name. 
                We will carry out the reimbursement using the same means of payment as you used for the initial transaction. 
              </li>
              <li className="terms-item noStyle"><b>6.3. </b>Cancellation and access: Once we receive your cancellation request, you will cease to have access to the site immediately.</li>
              <li className="terms-item noStyle"><b>6.4. </b>Abuse / policy violations: We may deny a refund request if we reasonably believe there us fraud, abuse, or a violation of these Terms.</li>
              <li className="terms-item noStyle"><b>6.5. </b>Mandatory rights: This policy does not limit consumer rights that cannot be waived under applicable law.</li>
            </ul>
          </div>
          <h3>7. Chargebacks and payment disputes</h3>
          <div className="content-area text-content">
            <ul className="terms-list">
              <li className="terms-item noStyle"><b>7.1. </b>If a payment is reversed or charged back, we may suspend or terminate access and account privileges until the matter is resolved. </li>
              <li className="terms-item noStyle"><b>7.2. </b>You agree to contact us first at support@vixacademy.com  to attempt to resolve any billing dispute before initiating a chargeback, without limiting your legal rights. </li>
            </ul>
          </div>
          <h3>8. License to access the Content (personal use only)</h3>
          <div className="content-area text-content">
            <ul className="terms-list">
              <li className="terms-item noStyle"><b>8.1. </b> Subject to these Terms and  your payment status, Vix Academy grants you a limited, personal, non-exclusive, non-transferable, 
              revocable license to access the Content for your own educational use. </li>
              <li className="terms-item noStyle"><b>8.2. </b> You may not copy, reproduce, distribute, resell, sublicense, share logins, publicly display, broadcast, or create 
                derivative works from the Content unless expressly permitted in writing by Vix Academy.</li>
            </ul>
          </div>
          <h3>9. Acceptable Use</h3>
          <div className="content-area text-content">
            <ul className="terms-list">
              <li className="terms-item noStyle"><b>9.1. </b> Use the site for unlawful, harmful, abusive, harassing, defamatory, or discriminatory purposes. </li>
              <li className="terms-item noStyle"><b>9.2. </b> Attempt unauthorized access to accounts, systems, or networks; probe security; or introduce malware.</li>
              <li className="terms-item noStyle"><b>9.3. </b> Scrape, copy, or download Content at scale, or use bots that degrade the Services.</li>
              <li className="terms-item noStyle"><b>9.4. </b> Share, sell, or redistribute Content or account access.</li>
            </ul>
          </div>
          <h3>10. Trading Fundamentals Program - educational disclaimer</h3>
          <div className="content-area text-content">
            <ul className="terms-list">
              <li className="terms-item noStyle"><b>10.1. </b> The Trading Fundamentals Program is provided for educational and informational purposes only.</li>
              <li className="terms-item noStyle"><b>10.2. </b> Nothing on the site or within the Content constitutes financial, investment, tax, legal, or trading advice, or a recommendation to buy or sell any asset.</li>
              <li className="terms-item noStyle"><b>10.3. </b> Trading and investing involve risk and may result in losses, including loss of capital. You are solely responsible
               for your decisions and should seek independent professional advice where appropriate.</li>
              <li className="terms-item noStyle"><b>10.4. </b> Past performance examples (if any) are not indicative of future results.</li>
            </ul>
          </div>
          <h3>11. Intellectual property</h3>
          <div className="content-area text-content">
            <ul className="terms-list">
              <li className="terms-item noStyle"><b>11.1. </b>The site, Services, trademarks, logos, and Content are owned by or licensed to Vix Academy and are protected by intellectual property laws.</li>
              <li className="terms-item noStyle"><b>11.2. </b>Except for the limited license granted in these Terms, no rights are transferred to you.</li>
            </ul>
          </div>
          <h3>12. Third-party services and links</h3>
          <div className="content-area text-content">
            <ul className="terms-list">
              <li className="terms-item noStyle"><b>12.1. </b>The site may contain links to third-party websites or tools (including payment processors). We do not control and are not responsible 
              for third-party content, policies, or practices. </li>
            </ul>
          </div>
          <h3>13. Availability and changes</h3>
          <div className="content-area text-content">
            <ul className="terms-list">
              <li className="terms-item noStyle"><b>13.1. </b>We may update, modify, or discontinue any part of the Services (including courses, features, or Content) at any time. </li>
              <li className="terms-item noStyle"><b>13.2. </b>We do not guarantee uninterrupted availability.</li>
            </ul>
          </div>
          <h3>14. Disclaimer of warranties</h3>
          <div className="content-area text-content">
            <ul className="terms-list">
              <li className="terms-item noStyle"><b>14.1. </b> To the maximum extent permitted by law, the site and Services are provided “as is” and “as available,”
               without warranties of any kind.</li>
            </ul>
          </div>
          <h3>15. Limitation of Liability</h3>
          <div className="content-area text-content">
            <ul className="terms-list">
              <li className="terms-item noStyle"><b>15.1. </b>To the maximum extent permitted by law, Vix Academy will not be liable for indirect, incidental, special, 
              consequential, or punitive damages.</li>
              <li className="terms-item noStyle"><b>15.2. </b>To the maximum extent permitted by law, Vix Academy’s total liability for any claim relating to the Services
               will not exceed the amount you paid to Vix Academy for the relevant Membership.</li>
            </ul>
          </div>
          <h3>16. Termination</h3>
          <div className="content-area text-content">
            <ul className="terms-list">
              <li className="terms-item noStyle"><b>16.1. </b> You may request cancellation as described in Section 6. </li>
              <li className="terms-item noStyle"><b>16.2. </b> We may suspend or terminate your access immediately if we reasonably believe you have violated these Terms, 
              engaged in fraud, or caused risk or harm to the Services or others.</li>
              <li className="terms-item noStyle"><b>16.3. </b> Upon termination, your license to access the Content ends.</li>
            </ul>
          </div>
          <h3>17. Privacy & Cookies</h3>
          <div className="content-area text-content">
            <ul className="terms-list">
              <li className="terms-item noStyle"><b>17.1. </b> Your use of the Services is also subject to our Privacy Policy and Cookie Policy published on the site.</li>
            </ul>
          </div>
          <h3>18. Governin law and jurisdiction (cross-border users)</h3>
          <div className="content-area text-content">
            <ul className="terms-list">
              <li className="terms-item noStyle"><b>18.1. </b> These Terms are governed by the laws of Cyprus, without regard to conflict of law rules.</li>
              <li className="terms-item noStyle"><b>18.2. </b> Mandatory local rights: If you reside in France, Italy, Brazil, Turkey, Hong Kong, Taiwan, Singapore, or Malaysia, 
                you may also benefit from mandatory consumer protection laws applicable in your place of residence, and nothing in these Terms limits such mandatory rights.</li>
              <li className="terms-item noStyle"><b>18.3. </b> Subject to mandatory rules, disputes shall be submitted to the courts of Limassol, Cyprus. </li>
            </ul>
          </div>
          <h3>19. Changes to these Terms</h3>
          <div className="content-area text-content">
            <span>We may update these Terms from time to time by posting the updated version on the site. Continued use after the effective date constitutes acceptance, to the
              extent permitted by law.
            </span>
          </div>
          <div className="content-area text-content">
            For inquiries, questions and support please contact us from support@vixacademy.com 
            <span>VIX ACADEMY</span>
          </div>

        </div>
 
       </section>
    )
  }
  



export default Terms